export type AppTimezone = {
    label: string
    iana: string
}

/** Extend this list to add more rows on the Settings page. */
export const APP_TIMEZONES: AppTimezone[] = [
    { label: 'Romania', iana: 'Europe/Bucharest' },
    { label: 'Poland', iana: 'Europe/Warsaw' },
    { label: 'Belgium', iana: 'Europe/Brussels' },
    { label: 'Brazil', iana: 'America/Sao_Paulo' },
    { label: 'Croatia', iana: 'Europe/Zagreb' },
    { label: 'Serbia', iana: 'Europe/Belgrade' },
    { label: 'Greece', iana: 'Europe/Athens' },
]

export const UTC_IANA = 'UTC'
